module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/435.6c8eb385.png";